import domReady from '@wordpress/dom-ready';

domReady(() => {
  const tabButtons = document.querySelectorAll('.program-tab-button');
  const tabPanels = document.querySelectorAll('.program-tab-panel');
  const panelsAnchor = document.querySelector('#panelsAnchor');
  const sidebarToggle = document.querySelector('#program-tabs-sidebar-toggle');
  const sidebarContent = document.querySelector(
    '#program-tabs-sidebar-content'
  );

  if (sidebarToggle && sidebarContent) {
    sidebarToggle.addEventListener('click', () => {
      if (sidebarContent.classList.contains('expanded')) {
        sidebarContent.classList.remove('expanded');
        sidebarToggle.setAttribute('aria-expanded', 'false');
      } else {
        sidebarContent.classList.add('expanded');
        sidebarToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function changeProgramTab(tabID) {
    tabButtons.forEach((tabBtn) => {
      if (tabID === tabBtn.getAttribute('data-program-tab')) {
        tabBtn.setAttribute('aria-selected', 'true');
      } else {
        tabBtn.setAttribute('aria-selected', 'false');
      }
    });
    tabPanels.forEach((tabPanel) => {
      if (tabID === tabPanel.getAttribute('ID')) {
        tabPanel.style.display = 'block';
      } else {
        tabPanel.style.display = 'none';
      }
    });

    if (sidebarContent && sidebarContent.classList.contains('expanded')) {
      sidebarContent.classList.remove('expanded');
      sidebarToggle.setAttribute('aria-expanded', 'false');
    }

    if (tabID && '#' + tabID !== window.location.hash) {
      history.replaceState(null, '', '#' + tabID);
    }

    setTimeout(() => {
      if (panelsAnchor) {
        panelsAnchor.scrollIntoView();
      }
    }, 200);
  }

  if (0 < tabButtons.length) {
    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        changeProgramTab(tabButton.getAttribute('data-program-tab'));
      });
    });
  }

  function goToProgramTab(tabID) {
    const tabPanel = document.getElementById(tabID);

    if (!tabPanel) {
      return;
    }

    changeProgramTab(tabID);

    // Wait a frame so the browser commits the display:none -> block change
    // before starting the scroll — otherwise it jumps instead of animating.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        tabPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // Links (as opposed to the .program-tab-button tab controls) that point to
  // a tab, e.g. the hero "Apply Now" button. Intercepted so the browser's
  // own instant fragment-jump never fires and fights with the smooth scroll.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-program-tab]');

    if (!link) {
      return;
    }

    e.preventDefault();
    goToProgramTab(link.getAttribute('data-program-tab'));
  });

  function activateTabFromHash() {
    const hash = window.location.hash.replace('#', '');

    if (!hash) {
      return;
    }

    goToProgramTab(hash);
  }

  window.addEventListener('load', activateTabFromHash);
  window.addEventListener('hashchange', activateTabFromHash);
});
